var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMountains(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#6D91A9"
    },
    width: 512,
    height: 399.997
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 368.003,
    cy: 95.995,
    r: 88.001
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F2F2F2"
    },
    d: "M368,8c-11.304,0-22.071,2.209-32,6.091c32.76,12.81,56,44.612,56,81.91s-23.241,69.098-56,81.91 c9.929,3.883,20.696,6.091,32,6.091c48.601,0,88-39.399,88-88S416.601,8,368,8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CCCCCC"
    },
    d: "M368,8c-5.484,0-10.832,0.54-16.03,1.518C392.936,17.04,424,52.86,424,95.999 s-31.065,78.96-72.029,86.481c5.196,0.979,10.546,1.518,16.03,1.518c48.601,0,88-39.399,88-88S416.601,8,368,8z"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 264.004,
    style: {
      fill: "#3C6C8C"
    },
    width: 512,
    height: 136.004
  }), /*#__PURE__*/React.createElement("rect", {
    y: 304.003,
    style: {
      fill: "#0B476F"
    },
    width: 512,
    height: 95.995
  }), /*#__PURE__*/React.createElement("rect", {
    y: 400.645,
    style: {
      fill: "#C69C6D"
    },
    width: 512,
    height: 104.312
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#534741"
    },
    points: "312,400 372,340 432,400 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#C7B299"
    },
    points: "496,504.686 412,420.343 360,464.515 392,504.686 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#998675"
    },
    points: "368,472 412,420 410.645,502.596 400,504  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#998675"
    },
    points: "56,504 152,232 239.999,368 268,340 392,504  "
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#534741"
    },
    points: "15.999,504.686 40,448.343 64,472.514 56,504.686 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C7B299"
    },
    d: "M232,504.686l-80.001-264.342l88,127.829c0,0,24.997-31.406,28-27.743s124,164.257,124,164.257H232z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#998675"
    },
    points: "268,340 271.999,408 239.999,376 "
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M368,191.837c-52.845,0-95.837-42.992-95.837-95.837S315.156,0.163,368,0.163S463.837,43.155,463.837,96 S420.845,191.837,368,191.837z M368,15.836c-44.202,0-80.164,35.961-80.164,80.164s35.961,80.164,80.164,80.164 S448.164,140.202,448.164,96S412.202,15.836,368,15.836z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 216.294,
    y: 48.065,
    style: {
      fill: "#FFFFFF"
    },
    width: 15.673,
    height: 15.673
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80.457,
    y: 96.131,
    style: {
      fill: "#FFFFFF"
    },
    width: 15.673,
    height: 15.673
  }), /*#__PURE__*/React.createElement("rect", {
    x: 263.314,
    y: 207.935,
    style: {
      fill: "#FFFFFF"
    },
    width: 16.718,
    height: 15.673
  }), /*#__PURE__*/React.createElement("rect", {
    x: 439.902,
    y: 240.327,
    style: {
      fill: "#FFFFFF"
    },
    width: 16.718,
    height: 15.673
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.131,
    y: 272.718,
    style: {
      fill: "#FFFFFF"
    },
    width: 16.718,
    height: 15.673
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.033,
    y: 256,
    style: {
      fill: "#FFFFFF"
    },
    width: 15.673,
    height: 15.673
  }), /*#__PURE__*/React.createElement("rect", {
    x: 463.935,
    y: 352.131,
    style: {
      fill: "#FFFFFF"
    },
    width: 15.673,
    height: 15.673
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#FFFFFF"
    },
    width: 15.673,
    height: 15.673
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M512,407.51v-15.673h-77.08L372,328.917l-58.399,58.399l-44.778-59.222l-27.509,27.51l-91.396-141.249L87.276,391.837H0 v15.673h81.744l-18.562,52.591l-25.827-25.827l-26.594,62.052H0V512h512v-15.673h-12.59L412,408.918l-46.733,46.732l-36.398-48.139 H512z M412.753,391.837h-81.507L372,351.083L412.753,391.837z M154.083,249.645l84.603,130.751l28.491-28.49l109.196,144.421H67.019 L154.083,249.645z M42.643,461.726l14.758,14.758l-7.004,19.843H27.815L42.643,461.726z M412,431.083l65.243,65.243h-81.221 l-21.211-28.054L412,431.083z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMountains);
export default __webpack_public_path__ + "static/media/mountains.171548753e389bd244775936013ac817.svg";
export { ForwardRef as ReactComponent };